'use strict';

var processInclude = require('./util');

$(function () {
    processInclude(require('./contactUs/contactUs'));
});
